"use client";

import NarrativeSidebar from "../sidebars/NarrativeSidebar";
import { NarrativeOutput } from "./NarrativeOutput";
import useAdsPageStore from "../../store/adsPageStore";
import { useEffect } from "react";
import { getVideoByOwnerId } from "../../services/ads/videos/videosService";
import { useVideo } from "../../context/VideoContext";

interface HyphensTabContentProps {
  productId?: string;
  hideActions?: boolean;
  embedded?: boolean;
  externalProductFilter?: string | null;
  externalAngleFilter?: string | null;
}

export default function HyphensTabContent({ productId, hideActions, embedded, externalProductFilter, externalAngleFilter }: HyphensTabContentProps) {
  const { selectedNarrative } = useAdsPageStore();
  const { setVideos } = useVideo();

  const getListVideosService = async () => {
    await getVideoByOwnerId()
      .then((response) => {
        setVideos(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getListVideosService();
  }, []);

  if (embedded) {
    return (
      <div className="flex flex-1 min-h-0 overflow-hidden border-t border-gray-200 mr-6">
        <div className="w-[35%] min-w-[280px] max-w-[360px] flex-shrink-0">
          <NarrativeSidebar initialProductId={productId} hideHeader compact hideFilters externalProductFilter={externalProductFilter} externalAngleFilter={externalAngleFilter} />
        </div>
        <div className="flex-1 overflow-y-auto">
          {selectedNarrative && (
            <NarrativeOutput
              getListVideosService={getListVideosService}
              productId={selectedNarrative.product_information?.id || ""}
              narrativeId={selectedNarrative.id || ""}
              narrative={selectedNarrative.content_narrative}
              style={selectedNarrative.style || ""}
              title={selectedNarrative.narrative_name}
              videoType={selectedNarrative.video_type}
              hideActions={hideActions}
              embedded
            />
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-[#F5F6FA] h-screen overflow-hidden scrollbar-hide font-['Plus_Jakarta_Sans']">
      <NarrativeSidebar initialProductId={productId} />

      <div className="flex-1 overflow-y-auto">
        {selectedNarrative && (
          <NarrativeOutput
            getListVideosService={getListVideosService}
            productId={selectedNarrative.product_information?.id || ""}
            narrativeId={selectedNarrative.id || ""}
            narrative={selectedNarrative.content_narrative}
            style={selectedNarrative.style || ""}
            title={selectedNarrative.narrative_name}
            videoType={selectedNarrative.video_type}
            hideActions={hideActions}
          />
        )}
      </div>
    </div>
  );
}
